import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core";
import {AdminContextConsumer} from './Admin';
import MUIDataTable from "mui-datatables";
import firebaseApp from "../common/firebase";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import Grid from "@material-ui/core/Grid/Grid";
import moment from "moment";
import {isNullOrUndefined} from "util";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Avatar from "@material-ui/core/Avatar/Avatar";
import placeholder from "../assets/placeholder.svg";
import ListItem from "@material-ui/core/ListItem/ListItem";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import RefreshIcon from "@material-ui/icons/Refresh";
import IconButton from "@material-ui/core/IconButton/IconButton";


const firestore = firebaseApp.firestore();


const styles = theme => ({
    progress: {
        margin: theme.spacing.unit * 2,
    },
});

class Reportings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            elements: [],
        };
    }


    UNSAFE_componentWillMount() {
        this.reload();
    }

    reload = () => {
        this.setState({loading: true}, async () => {
            try {


                let fsElements = await firestore.collection("reports").orderBy("created", "desc").get();

                let elements = [];

                for (const fsElement of fsElements.docs) {

                    let fsProfile = await firestore.collection("profiles").doc(fsElement.data().uid).get();

                    const image = fsProfile.data().image;
                    const name = `${fsProfile.data().firstname} ${fsProfile.data().lastname}`;
                    const {created, ...other} = fsElement.data();
                    const element = {created: created.toDate(), image: image, name: name, ...other, id: fsElement.id}
                    elements.push(element)
                }

                this.setState({elements: elements, loading: false});
            } catch (error) {
                console.error(error);
                this.setState({loading: false});
            }

        })

    };


    render() {
        const {classes} = this.props;

        const columns = [
            {

                name: "Created",
                field: "created",
                options: {
                    filter: false,
                    sort: true,
                    display: "false",
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <React.Fragment>
                                {moment(value).format("YYYY-MM-DD, HH:mm:ss")}
                            </React.Fragment>

                        );
                    },
                }
            },
            {

                name: "Reporter uid",
                field: "uid",
                options: {
                    filter: false,
                    sort: true,
                    display: "false",
                }
            },
            {

                name: "Reporter",
                field: "image",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <Tooltip title={value.alt}>

                                {value.src ? (
                                    <Avatar
                                        alt={value.alt}
                                        src={value.src}
                                    />
                                ) : (
                                    <Avatar
                                        alt={value.alt}
                                        src={placeholder}
                                    />)}

                            </Tooltip>

                        );
                    },
                }
            },
            {

                name: "Reporter",
                field: "name",
                options: {
                    filter: false,
                    sort: true,
                    display: "true",
                }
            },
            {

                name: "Kind",
                field: "kind",
                options: {
                    filter: true,
                    sort: true,
                    display: "true",
                }
            },
            {

                name: "Reason",
                field: "reason",
                options: {
                    filter: true,
                    sort: true,
                    display: "true",
                }
            },
            {

                name: "Report",
                field: "report",
                options: {
                    filter: false,
                    sort: true,
                    display: "true",
                }
            },
            {

                name: "Subject",
                field: "subject",
                options: {
                    filter: false,
                    sort: true,
                    display: "true",
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <ListItem>
                                {value.src ? (
                                    <Avatar
                                        alt={value.alt}
                                        src={value.src}
                                    />
                                ) : (
                                    <Avatar
                                        alt={value.alt}
                                        src={placeholder}
                                    />)}
                                <ListItemText primary={value.primary} secondary={value.secondary}/>
                            </ListItem>

                        );
                    },
                }
            },
            {

                name: "Reported uid",
                field: "reportedUid",
                options: {
                    filter: false,
                    sort: true,
                    display: "false",
                }
            },
            {

                name: "Reported Event Id",
                field: "reportedEventId",
                options: {
                    filter: false,
                    sort: true,
                    display: "false",
                }
            },

        ];


        const options = {
            filter: true,
            filterType: 'dropdown',
            selectableRows: 'none',
            responsive: 'scrollFullHeight',
            customToolbar: () =>
                <Tooltip title={"Reload Data"}>
                    <IconButton className={classes.iconButton}
                                onClick={this.reload}>
                        <RefreshIcon/>
                    </IconButton>
                </Tooltip>,
        };

        const data = this.state.elements.map(element => {

            const line = [];

            for (const column of columns) {

                let field = element[column.field];

                if (column.field === "image") {
                    field = {src: element.image, alt: `${element.name}`}
                }

                if (column.field === "subject") {
                    if (element.kind === "guest" && element.subject.ccId) {
                        field = {
                            src: element.subject.guest.image,
                            primary: element.subject.guest.firstname,
                            secondary: `uid: ${element.subject.uid}, eventId: ${element.subject.eventId}`
                        }
                    }

                    if (element.kind === "guest" && !element.subject.ccId) {
                        field = {
                            src: element.subject.image,
                            primary: element.subject.name,
                            secondary: `uid: ${element.subject.uid}`
                        }
                    }

                    if (element.kind === "event") {
                        field = {
                            src: element.subject.host.image,
                            primary: `${element.subject.host.firstname} ${element.subject.host.lastname}`,
                            secondary: `eventId: ${element.subject.id}`
                        }
                    }
                }

                if (column.field === "reportedUid") {
                    if (element.kind === "guest") {
                        field = element.subject.uid
                    }

                    if (element.kind === "event") {
                        field = element.subject.uid
                    }
                }

                if (column.field === "reportedEventId") {
                    if (element.kind === "event") {
                        field = element.subject.id
                    }
                }


                if (isNullOrUndefined(field)) {
                    field = "-";
                }

                line.push(field);
            }

            return line;
        });

        return (
            <React.Fragment>
                <AdminContextConsumer>
                    {({page}) => (
                        <React.Fragment>

                            {this.state.loading ? (
                                    <Grid
                                        container
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <CircularProgress className={classes.progress} size={50}/>
                                    </Grid>
                                ) :
                                (
                                    <MUIDataTable
                                        columns={columns}
                                        data={data}
                                        title={page.title}
                                        options={options}
                                    />
                                )}

                        </React.Fragment>
                    )}
                </AdminContextConsumer>
            </React.Fragment>
        );
    }
}

Reportings.propTypes = {
    classes: PropTypes.object.isRequired,
};


export default withStyles(styles, {withTheme: true})(Reportings)